import { SystemStyleObject } from '@mui/system';
import { Theme } from '@mui/material/styles';

export const alertTitleSx: SystemStyleObject<Theme> = {
  textAlign: 'left',
  m: 0,
  lineHeight: 20,
  '&:first-letter': { textTransform: 'capitalize' },
};
